// src/pages/ProductDetailPage.jsx
import React, { useState } from 'react';
import {  useLocation, useParams } from 'react-router-dom';

import { Minus, Plus } from 'lucide-react';
import { theme } from '../utils/constants';

// Helper function to create a URL-friendly slug from title
const createSlug = (title) => {
  if (!title) return '';
  return title
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')        // Replace spaces with -
    .replace(/[^\w-]+/g, '')     // Remove all non-word chars
    .replace(/--+/g, '-')        // Replace multiple - with single -
    .replace(/^-+/, '')          // Trim leading -
    .replace(/-+$/, '');         // Trim trailing -
};

export default function ProductDetailPage({ addToCart, navigateTo, allProducts }) {
  // ─── All hooks first (required by React) ─────────────────────────
  // const navigate = useNavigate();
  const { slug } = useParams();           // :slug from URL
  const { state } = useLocation();        // optional passed product

  const [selectedSize, setSelectedSize] = useState('');
  const [selectedColor, setSelectedColor] = useState('');
  const [quantity, setQuantity] = useState(1);

  // ─── Resolve product ─────────────────────────────────────────────
  // Priority 1: passed via navigation state (fastest)
  let product = state?.product;

  // Priority 2: find in allProducts by matching slug
  if (!product && allProducts && slug) {
    product = allProducts.find((p) => createSlug(p.title) === slug);
  }

  // Not found → show fallback UI
  if (!product) {
    return (
      <div style={{ padding: '6rem 24px', textAlign: 'center' }}>
        <h2>Product not found</h2>
        <button
          onClick={() => navigateTo('shop')}
          style={{
            marginTop: '1.5rem',
            background: theme.primary,
            color: 'white',
            border: 'none',
            padding: '0.9rem 2rem',
            borderRadius: '50px',
            cursor: 'pointer',
            fontSize: '1.1rem'
          }}
        >
          Back to Shop
        </button>
      </div>
    );
  }

  // ─── Normal product detail logic ─────────────────────────────────
  const hasSizes = product.variants?.sizes?.length > 0;
  const hasColors = product.variants?.colors?.length > 0;

  const handleAdd = () => {
    if (hasSizes && !selectedSize) return alert("Please select a size");
    if (hasColors && !selectedColor) return alert("Please select a color");

    addToCart({
      ...product,
      quantity,
      selectedSize: selectedSize || null,
      selectedColor: selectedColor || null,
      variantId: `${product.id}-${selectedSize || ''}-${selectedColor || ''}`
    });

    alert(`${product.title} added to cart!`);
  };

   // <section style={{ padding: '6rem 24px 8rem', background: 'white', maxWidth: '1280px', margin: '0 auto' }}>

  return (
    <section
  style={{
    padding: '5rem 24px 7rem',
    background: '#fff',
    maxWidth: '1400px',
    margin: '0 auto'
  }}>

   
      <button
        onClick={() => navigateTo('shop')}
        style={{
          background: 'none',
          border: 'none',
          color: theme.primary,
          fontSize: '1.1rem',
          marginBottom: '2.5rem',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 8
        }}
      >
        ← Back to Shop
      </button>
        <div
  style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))',
    gap: '4rem',
    alignItems: 'start'
  }}
>
      {/* <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(420px, 1fr))', gap: '4rem', alignItems: 'start' }}> */}
        {/* <div style={{ borderRadius: '16px', overflow: 'hidden', boxShadow: theme.shadowMd }}> */}
        <div
          style={{
            borderRadius: '20px',
            overflow: 'hidden',
            boxShadow: '0 20px 45px rgba(0,0,0,0.12)',
            background: '#fafafa'
          }}
        >
          {/* <img src={product.image} alt={product.title} style={{ width: '100%', height: 'auto', display: 'block' }} /> */}
          <img
              src={product.image}
              alt={product.title}
              style={{
                width: '100%',
                height: '600px',
                objectFit: 'cover',
                display: 'block'
              }}
            />
        </div>

        <div>
          <h1 style={{ fontSize: '2.6rem', margin: '0 0 0.8rem', fontFamily: "'Roboto Slab', serif" }}>
            {product.title}
          </h1>

          <p style={{ color: theme.textLight, fontSize: '1.15rem', margin: '0 0 1.5rem' }}>
            {product.author}
          </p>

          {/* <p style={{ fontSize: '2.2rem', fontWeight: 700, color: theme.primary, margin: '0 0 2rem' }}>
            zmk{product.price.toFixed(2)}
          </p> */}

            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '14px',
                background: '#fafafa',
                border: `1px solid ${theme.border}`,
                padding: '16px 24px',
                borderRadius: '14px',
                marginBottom: '2rem'
              }}
            >
              <span
                style={{
                  background: theme.primary,
                  color: '#fff',
                  padding: '7px 12px',
                  borderRadius: '8px',
                  fontSize: '.75rem',
                  fontWeight: 700,
                  letterSpacing: '1px'
                }}
              >
                ZMK
              </span>

              <span
                style={{
                  fontSize: '3rem',
                  fontWeight: 800,
                  color: theme.primary,
                  lineHeight: 1
                }}
              >
                {product.price.toFixed(2)}
              </span>
            </div>

          <p style={{ lineHeight: 1.8, color: theme.textLight, marginBottom: '2.5rem' }}>
            {product.description || "No description available."}
          </p>

          {hasSizes && (
            <div style={{ marginBottom: '2rem' }}>
              <h4 style={{ margin: '0 0 1rem', fontSize: '1.15rem' }}>Size</h4>
              <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                {product.variants.sizes.map((s) => (
                  <button
                    key={s}
                    onClick={() => setSelectedSize(s)}
                    style={{
                      padding: '0.7rem 1.4rem',
                      border: selectedSize === s ? `2px solid ${theme.primary}` : `1px solid ${theme.border}`,
                      background: selectedSize === s ? theme.primary : 'white',
                      color: selectedSize === s ? 'white' : theme.text,
                      borderRadius: '50px',
                      fontWeight: 500,
                      cursor: 'pointer',
                      minWidth: '80px'
                    }}
                  >
                    {s}
                  </button>
                ))}
              </div>
            </div>
          )}

          {hasColors && (
            <div style={{ marginBottom: '2.5rem' }}>
              <h4 style={{ margin: '0 0 1rem', fontSize: '1.15rem' }}>Color</h4>
              <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                {product.variants.colors.map((c) => (
                  <button
                    key={c}
                    onClick={() => setSelectedColor(c)}
                    style={{
                      padding: '0.7rem 1.4rem',
                      border: selectedColor === c ? `2px solid ${theme.primary}` : `1px solid ${theme.border}`,
                      background: selectedColor === c ? `${theme.primary}15` : 'white',
                      color: theme.text,
                      borderRadius: '50px',
                      fontWeight: 500,
                      cursor: 'pointer',
                      minWidth: '100px'
                    }}
                  >
                    {c}
                  </button>
                ))}
              </div>
            </div>
          )}

          <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', border: `1px solid ${theme.border}`, borderRadius: '50px', overflow: 'hidden' }}>
              <button
                onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                style={{ padding: '0.9rem 1.2rem', background: 'none', border: 'none', fontSize: '1.3rem', cursor: 'pointer' }}
              >
                <Minus size={20} />
              </button>
              <span style={{ padding: '0.9rem 1.8rem', fontWeight: 600, minWidth: '60px', textAlign: 'center' }}>
                {quantity}
              </span>
              <button
                onClick={() => setQuantity((q) => q + 1)}
                style={{ padding: '0.9rem 1.2rem', background: 'none', border: 'none', fontSize: '1.3rem', cursor: 'pointer' }}
              >
                <Plus size={20} />
              </button>
            </div>

            <button
              onClick={handleAdd}
              style={{
                flex: 1,
                minWidth: '220px',
                background: `linear-gradient(90deg, ${theme.accent}, ${theme.accentDark})`,
                color: '#111',
                border: 'none',
                padding: '1rem 2rem',
                borderRadius: '50px',
                fontSize: '1.1rem',
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

// // src/pages/ProductDetailPage.jsx
// import React, { useState } from 'react';

// import { Minus, Plus } from 'lucide-react';

// import { theme } from '../utils/constants';

// export default function ProductDetailPage({ product, addToCart, navigateTo }) {
  
//   const { slug } = useParams();
//   const { state } = useLocation();
  
//   const [selectedSize, setSelectedSize] = useState('');
//   const [selectedColor, setSelectedColor] = useState('');
//   const [quantity, setQuantity] = useState(1);


//   ///here
  
//   ///here2

//   const hasSizes  = product?.variants?.sizes?.length  > 0;
//   const hasColors = product?.variants?.colors?.length > 0;

//   const handleAdd = () => {
//     if (hasSizes  && !selectedSize)  return alert("Please select a size");
//     if (hasColors && !selectedColor) return alert("Please select a color");

//     addToCart({
//       ...product,
//       quantity,
//       selectedSize:  selectedSize  || null,
//       selectedColor: selectedColor || null,
//       variantId: `${product.id}-${selectedSize || ''}-${selectedColor || ''}`
//     });

//     alert(`${product.title} added to cart!`);
//   };

//   return (
//     <section style={{ padding: '6rem 24px 8rem', background: 'white', maxWidth: '1280px', margin: '0 auto' }}>
//       {/* Back Button */}
//       <button
//         onClick={() => navigateTo('shop')}
//         style={{
//           background: 'none',
//           border: 'none',
//           color: theme.primary,
//           fontSize: '1.1rem',
//           marginBottom: '2.5rem',
//           cursor: 'pointer',
//           display: 'flex',
//           alignItems: 'center',
//           gap: 8
//         }}
//       >
//         ← Back to Shop
//       </button>

//       <div
//         style={{
//           display: 'grid',
//           gridTemplateColumns: 'repeat(auto-fit, minmax(420px, 1fr))',
//           gap: '4rem',
//           alignItems: 'start'
//         }}
//       >
//         {/* Product Image */}
//         <div style={{ borderRadius: '16px', overflow: 'hidden', boxShadow: theme.shadowMd }}>
//           <img
//             src={product?.image}
//             alt={product?.title}
//             style={{ width: '100%', height: 'auto', display: 'block' }}
//           />
//         </div>

//         {/* Product Info & Controls */}
//         <div>
//           <h1
//             style={{
//               fontSize: '2.6rem',
//               margin: '0 0 0.8rem',
//               fontFamily: "'Roboto Slab', serif"
//             }}
//           >
//             {product?.title}
//           </h1>

//           <p style={{ color: theme.textLight, fontSize: '1.15rem', margin: '0 0 1.5rem' }}>
//             {product?.author}
//           </p>

//           <p
//             style={{
//               fontSize: '2.2rem',
//               fontWeight: 700,
//               color: theme.primary,
//               margin: '0 0 2rem'
//             }}
//           >
//             zmk{product?.price.toFixed(2)}
//           </p>

//           <p style={{ lineHeight: 1.8, color: theme.textLight, marginBottom: '2.5rem' }}>
//             {product?.description || "No description available."}
//           </p>

//           {/* Size Selection */}
//           {hasSizes && (
//             <div style={{ marginBottom: '2rem' }}>
//               <h4 style={{ margin: '0 0 1rem', fontSize: '1.15rem' }}>Size</h4>
//               <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
//                 {product.variants.sizes.map(s => (
//                   <button
//                     key={s}
//                     onClick={() => setSelectedSize(s)}
//                     style={{
//                       padding: '0.7rem 1.4rem',
//                       border: selectedSize === s ? `2px solid ${theme.primary}` : `1px solid ${theme.border}`,
//                       background: selectedSize === s ? theme.primary : 'white',
//                       color: selectedSize === s ? 'white' : theme.text,
//                       borderRadius: '50px',
//                       fontWeight: 500,
//                       cursor: 'pointer',
//                       minWidth: '80px'
//                     }}
//                   >
//                     {s}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Color Selection */}
//           {hasColors && (
//             <div style={{ marginBottom: '2.5rem' }}>
//               <h4 style={{ margin: '0 0 1rem', fontSize: '1.15rem' }}>Color</h4>
//               <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
//                 {product.variants.colors.map(c => (
//                   <button
//                     key={c}
//                     onClick={() => setSelectedColor(c)}
//                     style={{
//                       padding: '0.7rem 1.4rem',
//                       border: selectedColor === c ? `2px solid ${theme.primary}` : `1px solid ${theme.border}`,
//                       background: selectedColor === c ? `${theme.primary}15` : 'white',
//                       color: theme.text,
//                       borderRadius: '50px',
//                       fontWeight: 500,
//                       cursor: 'pointer',
//                       minWidth: '100px'
//                     }}
//                   >
//                     {c}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Quantity + Add to Cart */}
//           <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', flexWrap: 'wrap' }}>
//             <div
//               style={{
//                 display: 'flex',
//                 border: `1px solid ${theme.border}`,
//                 borderRadius: '50px',
//                 overflow: 'hidden'
//               }}
//             >
//               <button
//                 onClick={() => setQuantity(q => Math.max(1, q - 1))}
//                 style={{ padding: '0.9rem 1.2rem', background: 'none', border: 'none', fontSize: '1.3rem', cursor: 'pointer' }}
//               >
//                 <Minus size={20} />
//               </button>
//               <span
//                 style={{
//                   padding: '0.9rem 1.8rem',
//                   fontWeight: 600,
//                   minWidth: '60px',
//                   textAlign: 'center'
//                 }}
//               >
//                 {quantity}
//               </span>
//               <button
//                 onClick={() => setQuantity(q => q + 1)}
//                 style={{ padding: '0.9rem 1.2rem', background: 'none', border: 'none', fontSize: '1.3rem', cursor: 'pointer' }}
//               >
//                 <Plus size={20} />
//               </button>
//             </div>

//             <button
//               onClick={handleAdd}
//               style={{
//                 flex: 1,
//                 minWidth: '220px',
//                 background: `linear-gradient(90deg, ${theme.accent}, ${theme.accentDark})`,
//                 color: '#111',
//                 border: 'none',
//                 padding: '1rem 2rem',
//                 borderRadius: '50px',
//                 fontSize: '1.1rem',
//                 fontWeight: 600,
//                 cursor: 'pointer'
//               }}
//             >
//               Add to Cart
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }